// extracted by mini-css-extract-plugin
export default {"horizontal":"horizontal-e24e","side":"side-47f2","dashed":"dashed-4282","label":"label-73e0"};